{
  "name": "login",
  "version": "0.0.1",
  "private": true,
  "type": "module",
  "dependencies": {
    "@openx/components-core": "*"
  }
}
